module.exports = __webpack_public_path__ + "img/imgexvirrew.57123ba6.png";